module.exports = __webpack_public_path__ + "static/media/ct_ago_favicon.f225e3ac.ico";